import { useCallback, useState } from 'react';

import client from '../api/client';

// Public "Contact Us" — POST /api/emailer/contact_us { email, subject, body }.
// No auth required (logged-out visitors can reach the store). `send` throws the
// axios error on failure so the form can map it via parseApiError.
export default function useContact() {
  const [loading, setLoading] = useState(false);

  const send = useCallback(async ({ email, subject, body }) => {
    setLoading(true);
    try {
      const { data } = await client.post('/emailer/contact_us', { email, subject, body });
      return data;
    } finally {
      setLoading(false);
    }
  }, []);

  return { send, loading };
}
